// this is as any'd and a random string because chrome doesn't respect autocomplete="off" on invididual inputs
// and form2 doesn't support passing autocomplete to the form itself
// https://stackoverflow.com/questions/12374442/chrome-ignores-autocomplete-off
// https://bugs.chromium.org/p/chromium/issues/detail?id=587466
export const autoCompleteOff = "autoCompleteOff" as any
